export default __webpack_public_path__ + "static/media/flag_china.bc5735d7.webp";